import { render, staticRenderFns } from "./ChangeZo.vue?vue&type=template&id=5ffa8ca2&scoped=true&"
import script from "./ChangeZo.vue?vue&type=script&lang=js&"
export * from "./ChangeZo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa8ca2",
  null
  
)

export default component.exports